import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=d1a7960a&scoped=true"
import script from "./ProfileDocuments.vue?vue&type=script&lang=js"
export * from "./ProfileDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProfileDocuments.vue?vue&type=style&index=0&id=d1a7960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a7960a",
  null
  
)

export default component.exports